var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsDefaultViewFilledIcon = function SvgDsDefaultViewFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.984 1.555a2.53 2.53 0 0 1 4.032 0c.26.344.688.521 1.116.462a2.53 2.53 0 0 1 2.85 2.851c-.058.428.119.855.463 1.116a2.53 2.53 0 0 1 0 4.032 1.2 1.2 0 0 0-.462 1.116 2.53 2.53 0 0 1-2.851 2.85 1.2 1.2 0 0 0-1.116.463 2.53 2.53 0 0 1-4.032 0 1.2 1.2 0 0 0-1.116-.462 2.53 2.53 0 0 1-2.85-2.851 1.2 1.2 0 0 0-.463-1.116 2.53 2.53 0 0 1 0-4.032c.344-.261.521-.688.462-1.116a2.53 2.53 0 0 1 2.851-2.85c.428.058.855-.119 1.116-.463m4.814 5.157a.667.667 0 1 0-1.025-.853l-2.39 2.868-1.197-1.198a.667.667 0 1 0-.943.942l1.714 1.715a.667.667 0 0 0 .984-.045z",
    clipRule: "evenodd"
  })));
};
export default SvgDsDefaultViewFilledIcon;